import { dependencyTypes } from "@/lib/utils";
import moment from "moment";

const TooltipContent = (props: any) => {
  const { data, dependencyList } = props;
  const dep = dependencyList?.find((deps: any) => deps?.target == data?.id);

  return (
    <>
      {data ? (
        <div className="bg-white p-4 flex flex-col gap-1">
          <div className="text-[15px] font-[600]">
            {data?.text || ""}
          </div>
          <div className="flex flex-row">
            <span className="text-[13px] text-gray-500 flex flex-col w-[120px]">{data?.isActual ? "Actual Start Date" : "Planned Start Date"} </span>
            <span className="text-[15px] font-[500]">: {data?.start ? moment(data.start).format('MM-DD-YYYY') : ""}</span>
          </div>          
          <div className="flex flex-row">
            <span className="text-[13px] text-gray-500 flex flex-col w-[120px]">{data?.isActual ? "Actual End Date" : "Planned End Date"} </span>
            <span className="text-[15px] font-[500]">: {data?.isActual ? data?.actualEndDate ? moment(data?.actualEndDate).format('MM-DD-YYYY') : "" : data?.end ? moment(data.end).format('MM-DD-YYYY') : ""}</span>
          </div>      
          {data?.isActual ?
            <div className="flex flex-row">
              <span className="text-[13px] text-gray-500 flex flex-col w-[120px]">{"Progress"} </span>
              <span className="text-[15px] font-[500]">: {data?.actualEndDate ? data?.progress : data?.actualProgress}%</span>
            </div> : <></>}
          {dep && Object.values(dep)?.length ? 
            <>
            <div className="flex flex-row">
              <span className="text-[13px] text-gray-500 flex flex-col w-[120px]">Dependent On</span>
              <span className="text-[15px] font-[500]">: {dep?.sourceName}</span>
            </div>          
            <div className="flex flex-row">
              <span className="text-[13px] text-gray-500 flex flex-col w-[120px]">Dependency</span>
              <span className="text-[15px] font-[500]">: {dependencyTypes[dep?.type as any] || ""}</span>
            </div>          
            <div className="flex flex-row">
              <span className="text-[13px] text-gray-500 flex flex-col w-[120px]">Lag Days</span>
              <span className="text-[15px] font-[500]">: {dep?.lagDays}</span>
            </div>
          </> : <></>}
        </div>
      ) : null}
    </>
  );
}

export default TooltipContent;